import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { ProcessoStatusService } from '../../../services/processo-status.service';

@Component({
  selector: 'app-processo-status-edit',
  templateUrl: './processo-status-edit.component.html',
  styleUrls: ['./processo-status-edit.component.scss']
})
export class ProcessoStatusEditComponent extends BaseFormComponent<any> implements OnInit {

  actionLabel: string = "Novo";

  constructor(
    public activatedRoute: ActivatedRoute,
    private myService: ProcessoStatusService,
    private navigation: NavigationService,
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      id: new FormControl(null),
      name: new FormControl(null, [Validators.required]),
    });

    if (this.entity?.id) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  voltar() {
    this.navigation.back([`/pre-projeto/admin/processo-status`]);
  }

  getDataCreate() {
    let data: any;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar() {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: any) => {
              this.msgSuccess('Status alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: any) => {
              this.confirmation('Status cadastrado com sucesso!').subscribe(() => {
                this.navigation.replace(['/pre-projeto', 'admin', 'processo-status']);
              });
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }
}
